import * as yup from 'yup';

export const signupValidations = yup.object().shape({
  firstName: yup
    .string()
    .required('Name is required')
    .max(24, 'Max 24 characters'),
  lastName: yup
    .string()
    .required('Last name is required')
    .max(24, 'Max 24 characters'),
  email: yup.string().email('Email invalid.').required('Email required.'),
  password: yup
    .string()
    .min(8, 'Password needs at least 8 characters')
    .matches(/[A-Z]/, 'Must contain at least one capital letter')
    .matches(/[a-z]/, 'Must contain at lease one lower case letter')
    .matches(/\d/, 'Must contain at least one digit')
    .required('Password is required'),
  passwordConfirm: yup
    .string()
    .required('Confirm Password is required')
    .oneOf([yup.ref('password')], 'Passwords must match'),
  acceptedTerms: yup.bool().oneOf([true], 'Must Accept Terms and Conditions'),
  phoneNumber: yup.string().required(),
});
